import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Grid, Button} from 'semantic-ui-react';


const ContentLayout:React.FC<React.PropsWithChildren<{}>> = (props) => {
  const { t } = useTranslation();

  const handleWebLink = () => {
    window.open("https://www.proware-solutions.de", "_blank")
  }

  const layout =<Grid >
    <Grid.Row style={{ "paddingTop":"2rem"}}>
      <Grid.Column width="2"></Grid.Column>
      <Grid.Column width="12" textAlign="center" >
      
        <h1>{t("main.welcome")}</h1>
      </Grid.Column>
      <Grid.Column width="2"></Grid.Column>
    </Grid.Row>
    <Grid.Row>
      <Grid.Column width="2"></Grid.Column>
      <Grid.Column width="12">{props.children}</Grid.Column>
      <Grid.Column width="2"></Grid.Column>
    </Grid.Row>
    <Grid.Row>
      <Grid.Column width="2"></Grid.Column>
      <Grid.Column width="12" textAlign="right">
        <Button as={Link} to="/imprint">
          {t("impressum.title")}
        </Button>
        <Button onClick={handleWebLink}>
          www.proware-solutions.de
        </Button>
      </Grid.Column>
      <Grid.Column width="2"></Grid.Column>
    </Grid.Row>
  </Grid>
  
  return layout;
}

export default ContentLayout;